import { Button } from '@/components/Button';
import { useAuth } from '@/features/auth/useAuth';

/**
 * Página inicial da área autenticada.
 *
 * Placeholder deliberado: o shell da aplicação — sidebar, topbar, breadcrumb,
 * paleta de comandos — é T-222, na Fase 2. O que existe aqui prova que a sessão
 * funciona de ponta a ponta e dá saída ao usuário.
 */
export function HomePage(): JSX.Element {
  const { session, signOut } = useAuth();

  if (session === null) {
    return <p>Sessão indisponível.</p>;
  }

  return (
    <main id="conteudo" style={{ padding: 'var(--space-8)', maxWidth: '48rem' }}>
      <h1>Olá, {session.user.name}</h1>

      <p style={{ marginTop: 'var(--space-2)', color: 'var(--text-secondary)' }}>
        {session.companies.length === 0
          ? 'Sua conta ainda não está ligada a nenhuma empresa.'
          : `Empresa ativa: ${
              session.companies.find((company) => company.id === session.activeCompanyId)
                ?.tradeName ?? '—'
            }`}
      </p>

      {session.companies.length > 0 && (
        <ul style={{ marginTop: 'var(--space-4)', paddingLeft: 'var(--space-5)' }}>
          {session.companies.map((company) => (
            <li key={company.id}>
              {company.tradeName} — {company.role}
            </li>
          ))}
        </ul>
      )}

      <div style={{ marginTop: 'var(--space-8)' }}>
        <Button onClick={() => void signOut()} variant="secondary">
          Sair
        </Button>
      </div>
    </main>
  );
}
